import React from 'react';

export type AdminStatusTone =
  | 'success'
  | 'warning'
  | 'critical'
  | 'info'
  | 'accent'
  | 'neutral'
  | 'dim'
  | 'line';

export interface StatusPillProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: AdminStatusTone;
}

export const StatusPill = React.forwardRef<HTMLSpanElement, StatusPillProps>(
  ({ tone = 'neutral', className = '', style, ...props }, ref) => (
    <span
      ref={ref}
      className={`admin-status-pill admin-status-pill--${tone} ${className}`.trim()}
      style={{ fontVariantNumeric: 'tabular-nums', ...style }}
      {...props}
    />
  )
);

StatusPill.displayName = 'StatusPill';
